import { Link, NavLink } from "react-router-dom";
import { footerContact, footerItem, socialIcons } from "../data/Data";
import Newsletter from "../home/Newsletter";
// import '../../../public/assets/img/logo/logo_trans.png'
export default function Footer() {
  return (
    <>
      <Newsletter />
      <div
        className="container-fluid btn-primary-custom text-light footer wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="p-3">
          <div className="row g-5">
            <div className="col-md-12 col-lg-4">
              <div className="">
                <Link to="/">
                  {/* <h1 className="text-white text-uppercase mb-3">BGM HOTEL</h1> */}
                  <img
                    src="/assets/img/logo/logo.png"
                    alt=""
                    className="w-100 d-lg-block d-dm-none d-sm-none d-none btn-dark-custom rounded p-2"
                  />
                  <img
                    src="/assets/img/logo/logo.png"
                    alt=""
                    className="w-25 d-md-block d-sm-none d-lg-none d-none btn-dark-custom rounded p-2"
                  />
                  <img
                    src="/assets/img/logo/logo.png"
                    alt=""
                    className="w-50 d-sm-block d-md-none d-lg-none btn-dark-custom rounded p-2"
                  />
                </Link>
                {/* <p className="text-white mb-0">
                  Build a professional website for your hotel business and grab
                  the attention of new visitors upon your site’s launch.
                </p> */}
              </div>
            </div>
            <div className="col-md-4 col-lg-3">
              <h6 className="section-title text-start text-warning text-uppercase mb-4">
                Contact
              </h6>
              {footerContact.map((val, footerKey) => (
                <p className="mb-2" key={footerKey}>
                  {val.icon} {val.name}
                </p>
              ))}
              <div className="d-flex pt-2">
                {socialIcons.slice(0, 10).map((val, index) => (
                  <NavLink
                    to={val.link}
                    className="btn btn-outline-light btn-social"
                    key={index}
                    target="_blank"
                  >
                    {val.icon}
                  </NavLink>
                ))}
              </div>
            </div>
            <div className="col-lg-5 col-md-8">
              <div className="row gy-5 g-4">
                {footerItem.map((section, sectionIndex) => (
                  <div className="col-md-6" key={sectionIndex}>
                    <h6 className="section-title text-start text-warning text-uppercase mb-4">
                      {section.header}
                    </h6>
                    {section.UnitItem.map((item, itemIndex) => (
                      // <Link to={to={item.link}}>

                      // </Link>
                      <ul className="navLink" key={itemIndex}>
                        <NavLink to={item.link}>
                          <span>{item.name}</span>
                        </NavLink>
                      </ul>
                      // <a
                      //   className="btn btn-link"
                      //   href={item.link}
                      //   key={itemIndex}
                      // >
                      //   {item.name}
                      // </a>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
